/*
 * File: /src/services/userNotificationService.js
 * The current users notification inbox
 *
 * Copyright (c) 2026 AdBase, Inc.
 */
import { authedAxios } from '../shared/axiosWrapper';
import { S2_USER_NOTIFICATIONS_PATH } from '../constants';

export default {
  // Newest first, page backwards with beforeId
  list(beforeId, limit, unreadOnly) {
    return authedAxios
      .get(S2_USER_NOTIFICATIONS_PATH, {
        params: {
          before_id: beforeId,
          limit: limit,
          unread_only: unreadOnly || undefined,
        },
      })
      .then((r) => r.data);
  },
  unreadCount() {
    return authedAxios
      .get(S2_USER_NOTIFICATIONS_PATH + 'unread-count')
      .then((r) => r.data.count);
  },
  markRead(id) {
    return authedAxios
      .put(S2_USER_NOTIFICATIONS_PATH + id + '/read')
      .then((r) => r.data.updated);
  },
  markAllRead() {
    return authedAxios
      .put(S2_USER_NOTIFICATIONS_PATH + 'read-all')
      .then((r) => r.data.updated);
  },
};
